import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { getRolesAndPermission } from '@piqet-angular/data';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
@Injectable({
  providedIn: 'root',
})
export class conversionDataGridService {
  processingDataConversionPayload: any;
  event: any;

  editConversion = new Subject<[any, any, any]>();
  editConversionData$ = this.editConversion.asObservable();

  deleteConversion = new Subject<[any]>();
  deleteConversionData$ = this.deleteConversion.asObservable();

  constructor(private swalService: SwalService) {}

  getconversionDataColumn(headerName?: any): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'OrderId',
      headerName: 'OrderId',
      field: 'OrderId',
      hide: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ConvertionProcessCategoryName',
      headerName: 'Conversion category',
      field: 'convertionProcessCategoryName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.innerHTML = `${cellValue}`;
        cellElement.style.textDecoration = 'underline';
        const showEdit = this.isAccess() ? this.isAccess().isEdit : true;
        if (showEdit) {
          cellElement.style.cursor = 'pointer';
        }
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          const showEdit = this.isAccess() ? this.isAccess().isEdit : true;
          const URL = location.href.split('/');
          const getRoutname = URL[URL.length - 1];
          const pathName =
            getRoutname == 'converting-processes'
              ? 'Review conversion process'
              : 'Review conversion detail';
          showEdit &&
            this.editConversion.next([
              params.data.convertionProcessId,
              params.data.regionId,
              pathName,
            ]);
        });
        return cellElement;
      },
    });

    {
      headerName != 'converting-processes' &&
        colDef.push({
          ...defaultColumn,
          colId: 'ConvertionProcessCode',
          headerName: 'Conversion code',
          field: 'convertionProcessCode',
          cellClass: 'my-permission-cursor-pointer',
          wrapText: true,
          autoHeight: true,
          lockVisible: true,
          resizable: false,
          editable: false,
          filter: 'agTextColumnFilter',
        });
    }

    colDef.push({
      ...defaultColumn,
      colId: 'ConvertionProcessName',
      headerName: 'Conversion process name',
      field: 'convertionProcessName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: true,
      filter: 'agTextColumnFilter',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'RegionCode',
      headerName: 'Region code',
      field: 'regionCode',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      filter: 'agTextColumnFilter',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'RegionName',
      headerName: 'Region',
      field: 'regionName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      filter: 'agTextColumnFilter',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'OrganizationName',
      headerName: 'Organization',
      field: 'organizationName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      filter: 'agTextColumnFilter',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellRendererParams: {
        showEdit: this.isAccess() ? this.isAccess().isEdit : true,
        showDelete: this.isAccess() ? this.isAccess().isDelete : true,
        showCopy: false,
        deleteData: (data: any) => {
          this.deleteCustomConfirmation(data);
        },
        editData: (data: any, pathName: any) => {
          const name =
            pathName == 'converting-processes'
              ? 'Review conversion process'
              : 'Review conversion detail';
          this.editConversion.next([data.convertionProcessId, data.regionId, name]);
        },
      },
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  isAccess = () => {
    return getRolesAndPermission(
      rolesModuleName.DataManageConvertingProcess,
      mainModuleName.dataManageMentModule
    );
  };

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getconversionDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.processingDataConversionPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'OrderId',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  deleteCustomConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteConversion.next([data]);
      } else {
      }
    });
  }
}
